import { useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";

import { DefaultResponseWithData } from "../models/system";
import { ILead } from "../models/Lead";
import apiConfig from "../utils/apiConfig";

export default function useVehicleLeads(vehicleId: string | null | undefined, componentName = "useVehicleLeads") {
  const { get, post, put } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();
  const staleTime = 1000 * 60 * 10; //10 minutes

  const vehicleLeads = useQuery({
    queryKey: ["vechicles", vehicleId, "leads"],
    queryFn: () => get<DefaultResponseWithData<ILead[]>>(`/vehicle/${vehicleId}/allLeads`),
    staleTime: staleTime,
    enabled: !!vehicleId
  });

  return {
    vehicleLeads
  };
}
